/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { useEffect, useCallback } from 'react';

import sumDollarAmounts from '../../../../../../../helpers/sumDollarAmounts';
import { formatCurrency } from '../../../../../../../helpers/currencyMask';

const thTextStyle =
  'absolute top-0 left-0 w-full h-full text-xs font-semibold uppercase text-slate-500 dark:text-slate-400 text-left';

const replaceThContent = (tr, content) => {
  const div = tr.children?.[0];

  if (div) {
    div.style.color = '#f8fafc';
    div.style.position = 'relative';

    const existingNewDiv = div.querySelector('.absolute');

    const tooltip = div.querySelector('.relative');

    if (tooltip) {
      tooltip.style.visibility = 'hidden';
    }

    if (existingNewDiv) {
      return;
    }

    const newDiv = document.createElement('div');
    newDiv.className = thTextStyle;
    newDiv.textContent = content;
    div.appendChild(newDiv);
  }
};

const replaceTdContent = (tr, content) => {
  const div = tr.children?.[0];

  if (div) {
    div.style.visibility = 'hidden';
  }

  tr.textContent = content;
};

const replaceColumnContent = (columnIndex, columnTitle, columnValue, table) => {
  const headerRow = table.rows[0];
  const headerRowCells = Array.from(headerRow.cells);

  const tr = headerRowCells[columnIndex];

  replaceThContent(tr, columnTitle);

  const firstDataRow = table.rows[1];

  if (!firstDataRow) {
    return;
  }

  const cells = Array.from(firstDataRow?.cells);

  const td = cells[columnIndex];

  replaceTdContent(td, columnValue);
};

const sumSimpleValues = (invoicesSource, propertyName) => {
  if (
    !invoicesSource ||
    !invoicesSource.length ||
    invoicesSource.some((invoice) => !invoice)
  ) {
    return '0.00';
  }

  const lineItems = invoicesSource.map((invoice) => invoice._line_items);
  const lineItemsFlat = lineItems.flat();
  const total = sumDollarAmounts(lineItemsFlat, propertyName);

  return total;
};

const sumAmmountsToApply = (
  invoicesSource,
  distributionPlan,
  skipLineItemsIds
) => {
  if (
    !invoicesSource ||
    !invoicesSource.length ||
    invoicesSource.some((invoice) => !invoice) ||
    !distributionPlan ||
    !distributionPlan.length
  ) {
    return '0.00';
  }

  const lineItems = invoicesSource
    .map((invoice) => invoice._line_items)
    ?.flat();

  const amounts = [];

  lineItems?.forEach((lineItem) => {
    if (
      skipLineItemsIds &&
      skipLineItemsIds.length &&
      skipLineItemsIds.includes(lineItem.id)
    ) {
      console.log('SKIP', skipLineItemsIds);
      return;
    }

    const amountToApply = distributionPlan?.find(
      (planItem) => planItem.line_item_id === +lineItem.id
    )?.amount;

    if (amountToApply) {
      amounts.push({ amount: amountToApply });
    }
  });

  const total = sumDollarAmounts(amounts, 'amount');

  return total;
};

export default function useSummary({
  ref,
  isSummary,
  rows,
  invoicesSource,
  distributionPlan,
  skipLineItemsIds,
}) {
  useEffect(() => {
    if (!isSummary || !ref?.current) {
      return;
    }

    const table = ref.current.querySelector('table');

    if (!table) {
      return;
    }

    const columns = [
      {
        title: 'Invoice(s) Total',
        value: `$${formatCurrency(sumSimpleValues(invoicesSource, 'amount'))}`,
      },
      {
        title: '',
        value: '',
      },
      {
        title: '',
        value: '',
      },
      {
        title: 'Amounts Applied',
        value: `$${formatCurrency(
          sumSimpleValues(invoicesSource, '_payment?.total')
        )}`,
      },
      {
        title: 'Amount to Apply',
        value: `$${formatCurrency(
          sumAmmountsToApply(invoicesSource, distributionPlan, skipLineItemsIds)
        )}`,
      },
      {
        title: '',
        value: '',
      },
    ];

    console.log('RUN');

    // Calculate the height of the first two rows
    const firstTwoRowsHeight = Array.from(table.rows)
      .slice(0, 2)
      .reduce((acc, row) => acc + row.clientHeight, 0);

    const tableParent = table.parentElement;

    // Set the max height of the table parent to the height of the first two rows so that only the first two rows are visible
    tableParent.style.maxHeight = `${firstTwoRowsHeight}px`;
    tableParent.style.overflowY = 'hidden';

    columns?.forEach((column, index) => {
      replaceColumnContent(index, column.title, column.value, table);
    });
  }, [
    distributionPlan,
    invoicesSource,
    isSummary,
    ref,
    rows,
    skipLineItemsIds,
  ]);
}
